module.exports = __webpack_public_path__ + "img/blusas.24a6173c.png";